import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import { Typewriter } from "react-simple-typewriter";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Google } from "@mui/icons-material";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { cn } from "../lib/utils";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import { AnimatePresence, motion } from "framer-motion";
import Seo from "../components/Seo";

const SignUp = () => {
  let navigate = useNavigate();
  const [credentials, setcredentials] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [submitload, setsubmitload] = useState(false);

  const handleGoogleSignIn = () => {
    console.log("Inside Google");
    setsubmitload(true);
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        // Signed in with Google
        const user = result.user;
        localStorage.setItem("userEmail", user.email);
        localStorage.setItem("uid", user.uid);
        user.getIdToken().then((token) => {
          localStorage.setItem("authToken", token);
          navigate("/");
        });
        localStorage.setItem("userName", user.displayName);
        handleCallback(user.displayName, user.email);
      })
      .catch((error) => {
        alert("Error Signing in with Google");
        console.error("Error signing in with Google:", error);
      });
    setsubmitload(false);
  };

  const handleSignUp = (event) => {
    event.preventDefault();
    setsubmitload(true);
    const displayName = credentials.name;
    firebase
      .auth()
      .createUserWithEmailAndPassword(credentials.email, credentials.password)
      .then(async (userCredential) => {
        // Handle successful sign up here
        const user = userCredential.user;
        await user.updateProfile({
          displayName: credentials.name,
        });
        console.log("Sign up successful!", user);
        localStorage.setItem("userEmail", user.email);
        localStorage.setItem("uid", user.uid);
        user.getIdToken().then((token) => {
          localStorage.setItem("authToken", token);
        });
        localStorage.setItem("userName", credentials.name);
        console.log("Created");
        handleCallback(displayName, user.email);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.error("Sign up failed:", errorCode, errorMessage);
        alert("Sign up Failed : " + errorMessage);
      });
    setsubmitload(false);
  };
  //////////////////////////up firebase
  //1)
  const handleCallback = async (name, email) => {
    setsubmitload(true);
    const response1 = await fetch(
      "https://animedoro-backend.vercel.app/api/googleentry",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name: name, email: email }),
      }
    );
    const json = await response1.json();
    if (!json.success) {
      alert("Sign in Failed");
    } else {
      navigate("/");
    }
    setsubmitload(false);
  };
  // useEffect(() => {
  //   /*global google*/
  //   google.accounts.id.initialize({
  //    client_id:"718156679991-vlktjgr7mkbpgqpu8iml8mnvjhguj2gt.apps.googleusercontent.com" ,
  //    callback: handleCallback
  //   });
  //   google.accounts.id.renderButton(
  //     document.getElementById("signInDiv"),
  //     {theme:"outline",size:"large",theme:"dark"}
  //   );
  // }, []);

  // const handleSubmit = async (e) => {
  //   setsubmitload(true);
  //   e.preventDefault();
  //   const response = await fetch("https://animedoro-backend-production.up.railway.app/api/createuser", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({name:credentials.name,email:credentials.email,password:credentials.password})
  //   });
  //   const json =await response.json()
  //   // console.log()
  //   if(!json.success){
  //     if(json.errors){ alert(json.errors[0].msg);}
  //     if(json["msg"]){alert(json["msg"]);}
  //     // else{alert("Enter valid credentials!");}
  //   }
  //   else{
  //   localStorage.setItem("userEmail",credentials.email);
  //   localStorage.setItem("authToken",json.authToken);
  //   localStorage.setItem("userName",credentials.name);
  //   navigate("/");}
  //   setsubmitload(false);
  // };

  const onChange = (event) => {
    setcredentials({ ...credentials, [event.target.name]: event.target.value });
  };
  const location = useLocation();

  return (
    <motion.div
      key={location.pathname}
      // initial={{ opacity: 0 }}
      // animate={{ opacity: 1 }}
      // exit={{ opacity: 0 }}
      // transition={{ duration: 2, ease: "easeInOut" }}
    >
      <Seo
        path="/signup"
        title="Sign Up — Start Studying with Animedoro"
        description="Create a free Otakufy account to start studying with the Animedoro method, join study rooms, track streaks and focus with friends."
        noindex
      />
      <Navbar />

      <div
        className="flex h-[90vh] flex-col items-center justify-center bg-muted p-6 md:p-10"
        style={{
          backgroundImage: "url('./images/radial-bg-2.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className=" w-full max-w-sm md:max-w-3xl">
          <motion.div
            key="card"
            className={cn("relative")}
            initial={{ opacity: 0, y: -600 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -600 }}
            transition={{ duration: 0.7, ease: "easeInOut" }}
          >
            {/* Blurred background overlay */}
            {/* <div className=" fixed inset-0 z-0 backdrop-blur-md bg-black/10"></div> */}
            <Card className=" !py-0 border-0 shadow-2xl overflow-hidden dark rounded-2xl !bg-neutral-950/90  relative z-10 backdrop-blur-md">
              <CardContent className=" md:grid  !p-0 md:grid-cols-2 gap-0  ">
                <form className=" p-6 md:py-8 md:px-8 w-full h-full mt-0 opacity-85 ">
                  <div className="flex flex-col gap-1">
                    <div className="flex flex-col items-center text-center gap-2 ">
                      <img
                        className="w-16 border rounded-xl !border-input shadow-2xl"
                        src="./android-chrome-512x512.png"
                        alt=""
                      />
                      <h1 className="!text-6xl headingtitle text-[#f5e8c7]">
                        Otakufy
                      </h1>
                      <p className="text-base text-balance text-muted-foreground"></p>
                    </div>
                    <div className="gap-0">
                      <Label htmlFor="name">Name</Label>
                      <Input
                        id="name"
                        type="text"
                        required
                        value={credentials.name}
                        name="name"
                        onChange={onChange}
                      />
                    </div>
                    <div className="gap-0">
                      <Label htmlFor="email">Email</Label>
                      <Input
                        id="email"
                        type="email"
                        // placeholder="lol@example.com"
                        required
                        value={credentials.email}
                        name="email"
                        onChange={onChange}
                      />
                    </div>
                    <div className="gap-0">
                      <Label htmlFor="password">Password</Label>
                      <Input
                        value={credentials.password}
                        onChange={onChange}
                        name="password"
                        id="password"
                        type="password"
                        required
                      />
                    </div>
                    <Button
                      type="submit"
                      disabled={submitload}
                      onClick={handleSignUp}
                      className="w-full bg-[#f5e8c7] text-bold text-black"
                    >
                      {submitload && (
                        <span
                          class="spinner-border spinner-border-sm mr-1"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                      Sign up
                    </Button>
                    <div className="gap-4">
                      <Button
                        className=" w-full mt-1"
                        variant="outline"
                        onClick={handleGoogleSignIn}
                      >
                        <svg
                          alt="Google sign-in"
                          className="w-5 mr-3"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
                            fill="currentColor"
                          />
                        </svg>
                        <span className="">Sign Up with Google</span>
                      </Button>
                    </div>
                    <div className="text-center text-xs text-neutral-400">
                      already have an account?{" "}
                      <Link
                        to="/login"
                        className="underline transition-all hover:text-[#f5e8c7] underline-offset-4 "
                      >
                        login
                      </Link>
                    </div>
                  </div>
                </form>
                <div className="relative hidden bg-muted md:block">
                  <img
                    style={{
                      objectPosition: "65% 50%",
                    }}
                    src="./images/timerimginvert2.webp"
                    alt="bg"
                    className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.95] "
                  />
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default SignUp;
// return (
